import React from 'react';
import { CloseOutlined } from "@ant-design/icons";
import { Col, Row, Spin } from "antd";
import { ManualControlECButton } from "./ManualControlECButton";
import { ShowDialog } from "../dialogs/ShowDialog";
import requestToAPI from "../../../lib/Request";
import { subscribe } from "../../../lib/RequestWS";
import { ParameterECButton } from './ParameterECButton';
import { RegulatorStateButton } from './RegulatorStateButton';
import { ChooseProgramButton } from './ChooseProgramButton';
import { RegulatorProtectButton } from './RegulatorProtectButton';
import { ParameterECDialog } from './ParameterECDialog';
import { RegulatorStateDialog } from './RegulatorStateDialog';
import { ManualControlECDialog } from './ManualControlECDialog';
import { CurrentProgramDialog } from './CurrentProgramDialog';
import { ChooseProgramDialog } from './ChooseProgramDialog';
import { DEVICE_TIMEOUT } from '../Const';
import moment from 'moment';

const programs = {
    0: "Рассада",
    2: "Предцвет",
    4: "Урожай",
    1: "Вегетация",
    3: "Цветение"
}

const MAIN_PAGE = 1;
const EC_PAGE = 2;
const MANUAL_CONTROL_PAGE = 3;
const REGULATOR_STATE_PAGE = 4;
const CHOOSE_PROGRAM_PAGE = 5;
const CURRENT_PROGRAM_PAGE = 6;

const PonicsDefaultMonitor = {}

export const WidgetECESP = ({ widgetId, deviceName, deviceId, closeWidget }) => {
    const [page, setPage] = React.useState(MAIN_PAGE);

    const [monitor, setMonitor] = React.useState(PonicsDefaultMonitor)
    const [crashes, setCrashes] = React.useState([])
    const [contextParams] = React.useState({})
    const [trueCrashes, setTrueCrashes] = React.useState([])
    const [isFetching, setIsFetching] = React.useState(true)
    const [dataMonitor, setDataMonitor] = React.useState([]); 
    const [deviceTimeouted, setDeviceTimeouted] = React.useState(false);
    let idDeviceTimeout = undefined;

    const udpateTimeout = () => {
        setDeviceTimeouted(false);
        clearTimeout(idDeviceTimeout);
        idDeviceTimeout = setTimeout(() => {
            setDeviceTimeouted(true);
        }, DEVICE_TIMEOUT);
    }

    React.useEffect(() => {
        contextParams.mountFlag = true;
        if (requestToAPI.authToken) {
            if (!contextParams.mountFlag) return;
            subscribe(
                `subscription { 
                    deviceUnitByPk(id: ${deviceId}) { 
                        monitor { 
                            updated
                            key
                            value 
                        }
                        model {
                          metadata
                        }
                    } 
                }`,
                (payload) => {
                    if(Object.keys(monitor).length != 0) {  // если обновляется в первый раз после загрузки страницы
                        udpateTimeout();
                    }
                    else {
                        const heartBeat = payload.data.deviceUnitByPk.monitor.find(parameter => parameter.key == 'heartBeat');
                        if(heartBeat && moment().diff(moment(heartBeat.updated)) > DEVICE_TIMEOUT) {
                            setDeviceTimeouted(true);
                        }
                        else {
                            udpateTimeout();
                        }
                    }

                    if (!contextParams.mountFlag) return;
                    let new_data = payload.data.deviceUnitByPk
                    if (new_data) {
                        var data = new_data.monitor.reduce(function (map, obj) {
                            map[obj.key] = obj.value;
                            return map;
                        }, {});
                        setMonitor(data)

                        let metadata = new_data.model.metadata && new_data.model.metadata.monitor ? new_data.model.metadata.monitor : {};
                        setDataMonitor(metadata);

                        let crash = []
                        let trueCrash = []
                        for (let key in data) {
                            let obj = {}
                            if (key.substr(0, 5) === 'alarm') {
                                obj["state"] = data[key]
                                obj["name"] = key.substr(5, 4)
                                obj["meta"] = metadata[key]

                                crash.push(obj)
                                if (obj.state) {
                                    trueCrash.push(obj)
                                }
                            }
                        }
                        setTrueCrashes(trueCrash)
                        setCrashes(crash)
                        setIsFetching(false)
                    } else {
                        setPage(MAIN_PAGE);
                    }
                }
            )
        }
        return () => {
            contextParams.mountFlag = false
        }
    }, [])

    return (
        <div className="main-widget">
            <div draggable="true" className={crashes.some(x => x.state) || deviceTimeouted ? "header-widget background-red" : "header-widget"}>
                <div />
                <div className={crashes.some(x => x.state) || deviceTimeouted ? "main-widget-title background-red" : "main-widget-title"}>
                    {`${deviceName}`}
                </div>
                <div className="area-widget-close" onClick={() => {
                    closeWidget(widgetId)
                }}>
                    <CloseOutlined
                        className={crashes.some(x => x.state) ? "widget-close-white widget-close" : "widget-close-main"}
                    />
                </div>
            </div>
            {
                (() => {
                    if (isFetching) {
                        return <Spin className="fetching-stat" />
                    }
                    switch (page) {
                        case EC_PAGE:
                            return <ShowDialog
                                title={"Настройка регулятора EC"}
                                widgetName={deviceName}
                                isAlarm={crashes.some(x => x.state) || deviceTimeouted}
                                number={widgetId}
                                value={"pH"}
                                changePage={() => setPage(MAIN_PAGE)}
                                component={
                                    <ParameterECDialog
                                        unitId={deviceId}
                                        ecCycleTm={monitor.ecCycleTm}
                                        ecCycleTmMin={0}
                                    />
                                }
                            />
                        case MANUAL_CONTROL_PAGE:
                            return <ShowDialog
                                title={"Ручное управление EC"}
                                isAlarm={crashes.some(x => x.state) || deviceTimeouted}
                                widgetName={deviceName}
                                number={widgetId}
                                value={"manualControl"}
                                changePage={() => setPage(MAIN_PAGE)}
                                component={<ManualControlECDialog
                                    unitId={deviceId}
                                    tankEc={monitor.tankEc}
                                    taskEcA={monitor.taskEcA}
                                    taskEcB={monitor.taskEcB}
                                    taskEcC={monitor.taskEcC}
                                    taskPhUpMax={50}
                                    taskPhDownMax={50}
                                />} />
                        case REGULATOR_STATE_PAGE:
                            return <ShowDialog
                                title={"Режим E-MODE"}
                                isAlarm={crashes.some(x => x.state) || deviceTimeouted}
                                widgetName={deviceName}
                                number={widgetId}
                                value={"mode"}
                                changePage={() => setPage(MAIN_PAGE)}
                                component={<RegulatorStateDialog
                                    isAlarm={crashes.some(x => x.state) || deviceTimeouted}
                                    deviceId={widgetId}
                                    widgetName={deviceName}
                                    crashes={crashes}
                                    unitId={deviceId}
                                    ecIsOn={monitor.ecIsOn}
                                />} />
                        case CHOOSE_PROGRAM_PAGE:
                            return <ShowDialog
                                title={"Программы EC"}
                                isAlarm={crashes.some(x => x.state) || deviceTimeouted}
                                widgetName={deviceName}
                                number={widgetId}
                                value={"mode"}
                                changePage={() => setPage(MAIN_PAGE)}
                                component={<ChooseProgramDialog
                                    unitId={deviceId}
                                    ecSp={monitor.ecSp}
                                    ecA={monitor.ecA}
                                    ecB={monitor.ecB}
                                    ecC={monitor.ecC}
                                    ecProgId={monitor.ecProgId}
                                    onParamZoneClick={(e) => { setPage(CURRENT_PROGRAM_PAGE) }}
                                    programs={programs}
                                />} />
                        case CURRENT_PROGRAM_PAGE:
                            return <ShowDialog
                                title={"Настройки: " + programs[monitor.ecProgId]}
                                isAlarm={crashes.some(x => x.state) || deviceTimeouted}
                                widgetName={deviceName}
                                number={widgetId}
                                value={"mode"}
                                changePage={() => setPage(CHOOSE_PROGRAM_PAGE)}
                                component={<CurrentProgramDialog
                                    unitId={deviceId}
                                    ecSp={monitor.ecSp}
                                    ecA={monitor.ecA}
                                    ecB={monitor.ecB}
                                    ecC={monitor.ecC}
                                />} />
                        default:
                            return <div>
                                <Row draggable="false" className='border-down'>
                                    <Col span={12} className="right-border-2px">
                                        <ParameterECButton
                                            tankEC={monitor.tankEc}
                                            tankTemp={monitor.tankTemp}
                                            handleClick={() => setPage(EC_PAGE)}
                                            trueCrashes={trueCrashes}
                                            ecTitle={dataMonitor.ecTitle}
                                            tempTitle={dataMonitor.tempTitle}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <ManualControlECButton
                                            outEcA={monitor.outEcA}
                                            outEcB={monitor.outEcB}
                                            outEcC={monitor.outEcC}
                                            handleClick={() => setPage(MANUAL_CONTROL_PAGE)}
                                        />
                                    </Col>
                                </Row>
                                <Row draggable="false" style={{ height: 112.5 }}>
                                    <Col span={6} className="right-border-2px">
                                        <RegulatorStateButton
                                            handleClick={() => setPage(REGULATOR_STATE_PAGE)}
                                            ecIsOn={monitor.ecIsOn}
                                            trueCrashes={trueCrashes}
                                            ecIsOnTitle={dataMonitor.ecIsOnTitle}
                                        />
                                    </Col>
                                    <Col span={6} className="right-border-2px">
                                        <ChooseProgramButton
                                            handleClick={() => setPage(CHOOSE_PROGRAM_PAGE)}
                                            chooseProgramTitle={dataMonitor.chooseProgramTitle}
                                            choosenProgram={programs[monitor.ecProgId]}
                                        />
                                    </Col>
                                    <Col span={6} className="right-border-2px">
                                        <RegulatorProtectButton
                                            unitId={deviceId}
                                            ecIsProtected={monitor.ecIsProtected}
                                            ecIsProtectedTitle={dataMonitor.ecIsProtectedTitle}
                                        />
                                    </Col>
                                </Row>
                            </div>
                    }
                })()
            }
        </div >
    )
}